import React from 'react';
import { TRUST_LINKS, NATIONAL_GAMBLING_HELPLINE, NATIONAL_GAMBLING_HELPLINE_TEL } from '../data/site';
import './truststrip.css';

export default function TrustStrip() {
  return (
    <section className="trust-strip" aria-label="Regulatory and safer gambling bodies">
      <div className="container trust-strip__inner">
        <span className="trust-strip__label">Licensed &amp; Regulated by:</span>
        <div className="trust-strip__logos">
          {TRUST_LINKS.map((t) => (
            <a
              key={t.name}
              href={t.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="trust-strip__item"
              title={t.description}
            >
              <span className="trust-strip__logo-wrap">
                <img src={t.logo} alt="" className="trust-strip__logo" />
              </span>
              <span className="trust-strip__name">{t.name}</span>
            </a>
          ))}
        </div>
        <div className="trust-strip__age">
          <span className="trust-strip__age-badge" aria-label="18 plus only">18+</span>
          <span className="trust-strip__age-text">UK players only · Gamble responsibly</span>
        </div>
      </div>
      <div className="container trust-strip__help">
        <span className="trust-strip__help-label">Need support?</span>
        <a href={NATIONAL_GAMBLING_HELPLINE_TEL} className="trust-strip__help-tel">{NATIONAL_GAMBLING_HELPLINE}</a>
        <span className="trust-strip__help-meta">National Gambling Helpline · 24/7 · Free</span>
      </div>
    </section>
  );
}
